<template>
  <div class="richmsg-type-3">
    <div class="content">
      <div class="desc-section" :class="questions.length > 0 ? '' : 'desc-section--only'">
        <template v-for="(item, index) in description">
          <a v-if="item.url" :key="index" :href="item.url" @click.prevent="handlLinkClick(item.url)">{{item.text}}</a>
          <span v-else :key="index">{{item.text}}</span>
        </template>
      </div>
      <template v-if="questions.length > 0">
        <div class="question-title">
          <div v-if="qlist.type && qlist.type == 2">你可能还想问：</div>
          <div v-else>亲，你是不是想问：</div>
        </div>
        <ul class="question-list">
          <li v-for="(item, index) in questions" class="question-item" :key="index">
            <a
              action="msg"
              :href="`qdweb://webim/message/ext2robotsendc2b?content=${textToUnicode(item.text)}&ext=${textToUnicode(JSON.stringify(item))}`"
            ><i class="question-icon"></i>{{item.text}}</a>
          </li>
        </ul>
      </template>
    </div>
  </div>

</template>

<script>
// import handlLinkClick from '@/components/mixin/handlLinkClick.js';
import { textToUnicode } from '@/utils/htmlDecode';

export default {
  name: 'qlist-msg',
  // mixins: [handlLinkClick],
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const msgData = this.message.content;

    const qlist = msgData.content || {};
    const description = qlist.description || [];
    const questions = qlist.questions || [];

    return {
      qlist,
      description,
      questions,
    };
  },
  methods: {
    handlLinkClick() {},
    /**
     * 点击问题
     */
    async handlQuestionClick(question, type) {
      const message = this.$qdim.createTextMessage({ text: question });
      message.qlist = {
        kfUin: this.$qdim.globalVars.receptionist.kfUin,
        type,
      };

      // 2. 存入store，上屏显示
      this.$store.commit('sendMessage', message);

      try {
        // 3. 异步发送消息
        await this.$qdim.sendMessage(message);
        // 4.1 发送成功
        this.$store.commit('changeMessageStatus', { message, status: 'success' });
      } catch (ex) {
        console.log('[send message error]', ex);
        // 4.2 发送失败
        this.$store.commit('changeMessageStatus', { message, status: 'fail' });
      }
    },
    /**
     * 将字符串中的 & 符转成unicode编码
     */
    textToUnicode(text)  {
      return textToUnicode(text);
    },
  },
};
</script>

<style lang="less" scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
  color: #444;
}
.richmsg-type-3 {
  .desc-section {
    width: 225px;
    font-size: 0;
    margin-bottom: 14px;

    span {
      font-size: 14px;
      line-height: 22px;
    }

    a {
      font-size: 14px;
      line-height: 22px;
      color: #4A70FF;
      cursor: pointer;
    }

    &--only {
      margin-bottom: 0;
    }
  }

  .question-title {
    font-size: 14px;
    line-height: 26px;
    font-weight: bold;
    margin-top: 5px;
  }

  .question-item {
    position: relative;
    width: 225px;
    font-size: 14px;
    line-height: 20px;
    margin-top: 7px;
    padding-left: 16px;

    a {
      cursor: pointer;
      &:hover {
        color: #4A70FF;
        .question-icon {
          background: url('../assets/quesion-icon-active.svg');
        }
      }
    }

    .question-icon {
      position: absolute;
      left: 1px;
      top: 5px;
      width: 8px;
      height: 8px;
      background: url('../assets/quesion-icon.svg');
    }
  }
}
.pc.pc-not-frame {
  .richmsg-type-3 {
    .desc-section {
      span, a {
        font-size: 15px;
        line-height: 24px;
      }
    }
    .question-title {
      font-size: 15px;
      line-height: 28px;
    }
    .question-item {
      font-size: 15px;
      line-height: 21px;
    }
  }
}
</style>
